module.exports = __webpack_public_path__ + "9232e92bc434c8a3e56aa3a4c37eb0fa.MP3";